import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--spacing-x-large);

	.motif-accordion-title-content {
		min-width: 0;
	}
`;
